import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RxBannerDismissibleComponent } from '@shared/components/rx-banner-dismissible/rx-banner-dismissible.component';

@Component({
	selector: 'rx-intuitive-patient-not-linked-banner',
	templateUrl: './rx-intuitive-patient-not-linked-banner.component.html',
	styleUrls: ['./rx-intuitive-patient-not-linked-banner.component.scss'],
	standalone: true,
	imports: [TranslateModule, RxBannerDismissibleComponent]
})
export class RxIntuitivePatientNotLinkedBannerComponent {
	@Output() dismissed = new EventEmitter<void>();
}
